module.exports = __webpack_public_path__ + "media/images/admin/image_attach-37bb842cd2da41c6b7b180617f6a1d7b.svg";